import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'CarConsul - AI-Powered Car Buying Assistant',
  description = 'AI-powered car buying assistant providing independent advice to help you find the perfect car at the best price',
  canonicalUrl = 'https://carconsul.com',
  pagePath = '',
  image = '/logo512.png',
  schemaMarkup = null
}) => {
  const pageUrl = pagePath ? `${canonicalUrl}/${pagePath}` : canonicalUrl;
  const imageUrl = image.startsWith('http') ? image : `${canonicalUrl}${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Canonical Tag */}
      <link rel="canonical" href={pageUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={pageUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={imageUrl} />
      
      {/* Schema.org markup */}
      {schemaMarkup && (
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
